import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { GlobalDataService } from './global-data.service';

export interface CommandeStatusPayload {
  codeStatut?: string;
  [key: string]: unknown;
}

export function normalizeStatutCommandeList(value: unknown): CommandeStatusPayload[] {
  if (Array.isArray(value)) {
    return value.filter(
      (status): status is CommandeStatusPayload => !!status && typeof status === 'object'
    );
  }

  return value && typeof value === 'object'
    ? [value as CommandeStatusPayload]
    : [];
}

@Injectable({
  providedIn: 'root'
})
export class StatutCommandeService {
  _url = environment.url_api + '/statut-commande';

  constructor(private _http: HttpClient,
    public _GlobalDataService: GlobalDataService,
  ) { }

  getStatutsByIdCommande(IdCommande: string) {
  
    // ATA@20230403 - Security enhancements
    // if (this._GlobalDataService.isTokenExpired(this._GlobalDataService.getJwtoken())) {
    //   this._GlobalDataService.refreshToken();
    // }    
    let url = this._url + '/commande/' + IdCommande;
    let observable = new Observable<any>(subscriber => {
      this._http.get<any>(url, { params: this._GlobalDataService.objectParams, headers: new HttpHeaders({ "Authorization": `Bearer ${this._GlobalDataService.getJwtoken()}` }) })
        .subscribe(response => {
          const statuts = normalizeStatutCommandeList(response?.StatutCommande);
          statuts.forEach(statut => {
            if (statut.codeStatut) {
              statut['StatutLibelle'] = this._GlobalDataService.mappingStatut[statut.codeStatut];
            }
          });
          subscriber.next({ ...(response || {}), StatutCommande: statuts });
          subscriber.complete();
        }, err => { subscriber.error(err); });
    });
    return observable
  }

  getStatutsByIdCommandeAdmin(IdCommande: string) {

    // ATA@20230403 - Security enhancements
    // if (this._GlobalDataService.isTokenExpired(this._GlobalDataService.getJwtoken())) {
    //   this._GlobalDataService.refreshToken();
    // }    
    let url = environment.url_api + '/admin-statut-commande/commande/' + IdCommande;
    let observable = new Observable<any>(subscriber => {
      this._http.get<any>(url, { params: this._GlobalDataService.objectParams, headers: new HttpHeaders({ "Authorization": `Bearer ${ this._GlobalDataService.getJwtoken() }` }) })
        .subscribe(response => {
          const statuts = normalizeStatutCommandeList(response?.StatutCommande);
          statuts.forEach(statut => {
            if (statut.codeStatut) {
              statut['StatutLibelle'] = this._GlobalDataService.mappingStatut[statut.codeStatut];
            }
          });
          subscriber.next({ ...(response || {}), StatutCommande: statuts });
          subscriber.complete();
        }, err => { subscriber.error(err); });
    });
    return observable
  }
}
